export const API_FAILURE_NOTIFICATION = 'API_FAILURE_NOTIFICATION'



// WEBPACK FOOTER //
// ./src/services/notifications/constants.js